import axios from './axios'
import localforage from 'localforage'
import _ from 'lodash'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import * as dataDictionary from '../assets/js/dataDictionary'
import envConst from '../const'
import eventBus from './eventbus'
import * as helper from './helper'
dayjs.extend(isBetween)
export default function(Vue) {
  Vue.prototype.$axios = axios
  Vue.prototype.$db = localforage
  Vue.prototype.$_ = _
  Vue.prototype.$dayjs = dayjs
  Vue.prototype.$dataDictionary = dataDictionary
  Vue.prototype.$envConst = envConst
  Vue.prototype.$eventBus = eventBus
  Vue.prototype.$helper = helper
}
